import { Close, Mic, Send } from '@mui/icons-material';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

import { Card } from '../dataDisplay/card';
import { Divider } from '../dataDisplay/divider/Divider';
import { LabeledInput } from '../input/labeled-input/LabeledInput';

import { ToniAILoadingIndicator } from './components/toni-ai-chat-bot-loading-indicator/ToniAIChatBotLoadingIndicator';
import { ToniAIChatMessage } from './components/toni-ai-chat-bot-message/ToniAIChatBotMessage';
import { useToniAIContext } from './components/ToniAIChatBotProvider';

export const ToniAIChatBot = () => {
  const {
    setOpen,
    term,
    setTerm,
    triggerGetEmail,
    loading,
    messages,
    currentStream,
  } = useToniAIContext();

  return (
    <Box height="100%" p="1rem" bgcolor="var(--ui03)">
      <Card style={{ height: '100%' }} noPadding>
        <Stack height="100%">
          <Stack direction="row" alignItems="center">
            <IconButton onClick={() => setOpen(false)}>
              <Close />
            </IconButton>
            <Typography variant="h4">Toni</Typography>
          </Stack>
          <Divider style={{ padding: 0 }} />
          <Stack flex="1" p="1rem" pb="5rem" gap="1rem" overflow="auto">
            {messages.map((item, idx) => {
              return <ToniAIChatMessage key={idx} item={item} />;
            })}
            {loading && (
              <Typography display="block" p="1rem">
                <ReactMarkdown>{currentStream}</ReactMarkdown>
                <ToniAILoadingIndicator />
              </Typography>
            )}
          </Stack>
          <Box
            p="1rem"
            position="absolute"
            right="1rem"
            left="1rem"
            bottom="1rem"
          >
            <form
              name="toni-ai-form"
              onSubmit={(e) => {
                e.preventDefault();
                triggerGetEmail();
              }}
            >
              <LabeledInput
                disabled={loading}
                value={term}
                onChange={(e) => setTerm(e.target.value)}
                style={{ borderRadius: '2rem' }}
                placeholder="Sprich mit mir"
                endAdornment={
                  <>
                    <IconButton disabled={loading}>
                      <Mic />
                    </IconButton>
                    <IconButton type="submit" disabled={loading}>
                      <Send />
                    </IconButton>
                  </>
                }
              />
            </form>
          </Box>
        </Stack>
      </Card>
    </Box>
  );
};
